// extracted by mini-css-extract-plugin
export var blog = "homeSectionBlogs-module--blog--b856a";
export var modalVideo = "homeSectionBlogs-module--modal-video--f7030";
export var modalVideoBody = "homeSectionBlogs-module--modal-video-body--1af6d";
export var modalVideoCloseBtn = "homeSectionBlogs-module--modal-video-close-btn--426d2";
export var modalVideoEffectExit = "homeSectionBlogs-module--modal-video-effect-exit--2d4b4";
export var modalVideoInner = "homeSectionBlogs-module--modal-video-inner--b0c05";
export var modalVideoMovieWrap = "homeSectionBlogs-module--modal-video-movie-wrap--4f15f";
export var section = "homeSectionBlogs-module--section--6cc74";
export var sectionRow = "homeSectionBlogs-module--section-row--9d0e8";
export var title = "homeSectionBlogs-module--title--189f1";
export var titleLine = "homeSectionBlogs-module--title-line--40f4b";
export var titleLink = "homeSectionBlogs-module--title-link--1f322";
export var titleText = "homeSectionBlogs-module--title-text--6c253";